export default {
  getProyectoUsuarioTpl: state => {
    let table = 'ProyectoUsuario'
    switch (state.operacion) {
      case 'edit':
      case 'new':
        table = `${table}Form`
        break
      default:
        table = `${table}List`
        break
    }
    return table
  },
}
